"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientChatsContext = void 0;
const ChatsContext_1 = require("./ChatsContext");
exports.PatientChatsContext = (0, ChatsContext_1.createChatContext)();
